<template>
    <div>
        <h1 class="mt-5"></h1>
    </div>
</template>

<script>

import moment from "moment";
export default {
    name:  "ListaInicio",
    props: [],
    components: {
    },
    data() {
        return {
           
        };
    },
    methods: {

    },

    created() {
       

    },
};

</script>
